import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
// import DownArrow from "../../../asset/images/down-arrow.svg";
import Lowarrow from "../../../asset/images/low-arrow.svg";
import UpArrow from "../../../asset/images/up-arrow.svg";
import { Constants } from "../../../CommonMethhods/Constants";
import Form from "react-bootstrap/Form";
// import Loader from "../Common/Loader";
import {
  forToFix,
  numDifferentiationWithoutSymbol,
} from "../../../CommonMethhods/CovertRupees";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  getTabStatus,
  goToClientDashboard,
  noDataFound,
  truncate,
} from "../../../CommonMethhods/CommonMethods";
import Loader from "../../Common/Loader";
import { get } from "jquery";
import SmallLoader from "../../Common/smallLoader";
import { toast } from "react-toastify";
import LoaderForSearch from "../../Common/LoaderForSearch";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function RevenueSnapshot(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [revenueEquModel, setRevenueEquModel] = useState([]);
  const [revenueOptionsModel, setRevenueOptionsModel] = useState([]);
  const [revenueFuturesModel, setRevenueFuturesModel] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModelFno, setShowModelFno] = useState(false);
  const [showModelMTF, setShowModelMTF] = useState(false);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [activeSegment, setActiveSegment] = useState("");
  // const [pageSize, setPageSize] = useState(5);

  const revenueTable = props.revenueTableData;
  const [loader, setLoader] = useState(true);
  const [infiniteScrollLoader, setInfiniteScrollLoader] = useState(false);
  const [duration, setDuration] = useState("");
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const title = props.title.split(" ")[0];
  const [fileType, setFileType] = useState("grid");
  const firstColumnTitle = title === "Sales" ? "Turnover" : title;
  const [serverError, setServerError] = useState("");
  const setShowRevModal = props.setShowRevModal;
  const setRevModalDuration = props.setRevModalDuration;
  const revModalDuration = props.revModalDuration;
  const revenueLoader = props.revenueLoader;

  const rowLabels = ["Equity", "Futures", "Options", "Total"];

  const handleifTableEmpty = (flag) => {
    const tempArray = [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ];

    return tempArray.map((column, index) => {
      return (
        <tr key={index} className="snapshot-table-row snapshot-body">
          {flag === true ? (
            <th className="text-left header-width first-col tooltip-manage">
              {rowLabels[index]}
              {rowLabels[index] === "Equity" && (
                <div className="tooltip123">
                  {truncate(<span className="icon-info-icon"></span>)}
                  <span className="tooltiptext new">Equity + MTF</span>
                </div>
              )}
            </th>
          ) : (
            <></>
          )}
          {column.map((v, index) => {
            return (
              <td key={index} className="snapshot-table-columns">
                {"0"}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  const getRevenueSnapshot = async (
    segment,
    durationKey,
    fileData = "grid",
    pageOverride = page,
  ) => {
    if (fileData === "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileData === "pdf") {
      setSmallLoaderPdf(true);
      setSmallLoaderExcel(false);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }

    const payloadValue = {
      segment: segment,
      duration: durationKey.toUpperCase(),
      fileType: fileData.toUpperCase(),
      pageNo: fileData === "grid" ? pageOverride : -1,
      pageSize: fileData === "grid" ? 10 : 1,
    };

    const encPayload = AESEncryption(payloadValue);

    try {
      const response = await axiosInstance.post(
        DASHBOARD_DEFAULT.RevenueSnapshotDetails,
        `"${encPayload}"`,
      );
      const decrypted = ApiResDecrypt(response?.data);
      //const decrypted = response?.data;
      const res = decrypted?.data;

      if (!res) return;

      if (fileData === "grid") {
        setTotalCount(res.totalCount || 0);

        if (segment === "EQ") {
          setRevenueEquModel((prev) =>
            page === 1 ? res.equityRevenues : [...prev, ...res.equityRevenues],
          );
        }
        if (segment === "FUT") {
          setRevenueFuturesModel((prev) =>
            page === 1 ? res.fnoRevenues : [...prev, ...res.fnoRevenues],
          );
        }
        if (segment === "OPT") {
          setRevenueOptionsModel((prev) =>
            page === 1 ? res.fnoRevenues : [...prev, ...res.fnoRevenues],
          );
        }
      } else {
        window.open(res, "_blank", "noopener,noreferrer");
      }

      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setInfiniteScrollLoader(false);
    } catch (error) {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setInfiniteScrollLoader(false);
      toast.error("Something went wrong, Please try again later.");
    }
  };

  const onHide = () => {
    setShowModal(false);
    setPage(1);
    setRevenueEquModel([]);
    setFileType("grid");
  };

  const onHideFno = () => {
    setShowModelFno(false);
    setPage(1);
    setRevenueFuturesModel([]);
    setFileType("grid");
  };
  const onHideMTF = () => {
    setShowModelMTF(false);
    setPage(1);
    setRevenueOptionsModel([]);
    setFileType("grid");
  };

  const handleFileType = (e) => {
    if (e.target.value) {
      props.handleOnClickSnapFileType(e.target.value, "Revenue");
    }
  };

  const handleViewClick = (column, durationKey) => {
    console.log(column, "check");
    
    setDuration(durationKey);
    setPage(1);
    setTotalCount(0);
    setLoader(true);

    if (column === "equity") {
      setActiveSegment("EQ");
      setShowModal(true);
      getRevenueSnapshot("EQ", durationKey);
    }

    if (column === "future") {
      setActiveSegment("FUT");
      setShowModelFno(true);
      getRevenueSnapshot("FUT", durationKey);
    }

    if (column === "options") {
      setActiveSegment("OPT");
      setShowModelMTF(true);
      getRevenueSnapshot("OPT", durationKey);
    }
  };

  const handleScroll = (segment, event) => {
    const target = event.target;

    const isBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - 1;

    if (!isBottom) return;
    if (segment !== activeSegment) return;
    if (infiniteScrollLoader) return;

    const currentLength =
      segment === "EQ"
        ? revenueEquModel.length
        : segment === "FUT"
          ? revenueFuturesModel.length
          : revenueOptionsModel.length;

    if (currentLength >= totalCount) return;

    const nextPage = page + 1;

    setInfiniteScrollLoader(true);
    setPage(nextPage);

    getRevenueSnapshot(segment, duration, "grid", nextPage);
  };

  const generateOverallTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      
      const columnValues = rows[column];
      rows[column].revenue = rows[column].revenue || 0;
      rows[column].revenueExist = rows[column].revenueExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;
console.log("column=", column);
      return (
        <tr key={index} className="snapshot-table-row snapshot-body">
          {/* {flag == true ? ( */}

          <th className="text-left header-width first-col tooltip-manage">
            {" "}
            {rowLabels[index]}
            {rowLabels[index] === "Equity" && (
              <div className="tooltip123">
                {truncate(<span className="icon-info-icon"></span>)}
                <span className="tooltiptext new">Equity + MTF</span>
              </div>
            )}
          </th>

          {/* ) : (
            <></>
          )} */}
          <td
            key={index}
            className="snapshot-table-columns overall-revenue"
            onClick={() => handleViewClick(column, "yesterday")}
          >
            <>
              <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                      ? Lowarrow
                      : UpArrow
                }
                alt=""
              />
              <>
                {/* <a
                  className="overall-revenue"
                  onClick={() => handleViewClick(column, "Yesterday")}
                > */}
                {columnValues.revenue == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.revenue)}
                {/* </a> */}
              </>
            </>
          </td>
          <td className="snapshot-table-columns">
            <span
              className={
                columnValues.revenueExist == 0
                  ? "text-muted"
                  : columnValues.revenueExist < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.revenueExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.revenueExist)}
            </span>
          </td>
          <td className="snapshot-table-columns">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          {/* <br /> */}
          <td className="snapshot-table-columns">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
        </tr>
      );
    });
  };

  //handle data
  const generateSnapshotTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].revenue = rows[column].revenue || 0;
      rows[column].revenueExist = rows[column].revenueExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row snapshot-body">
          {flag == true ? (
            <th className="text-left header-width first-col tooltip-manage">
              {" "}
              {rowLabels[index]}
              {rowLabels[index] === "Equity" && (
                <div className="tooltip123">
                  {truncate(<span className="icon-info-icon"></span>)}
                  <span className="tooltiptext new">Equity + MTF</span>
                </div>
              )}
            </th>
          ) : (
            <></>
          )}
          <td
            className="snapshot-table-columns overall-revenue"
            onClick={() => handleViewClick(column, revModalDuration)}
          >
            <>
              <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                      ? Lowarrow
                      : UpArrow
                }
                alt=""
              />
              <>
                {columnValues.revenue == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.revenue)}
              </>
            </>
          </td>
          <td className="snapshot-table-columns">
            <span
              className={
                columnValues.revenueExist == 0
                  ? "text-muted"
                  : columnValues.revenueExist < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.revenueExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.revenueExist)}
            </span>
          </td>
          <td className="snapshot-table-columns">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          {/* <br /> */}
          <td className="snapshot-table-columns">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
          {/* {Object.keys(columnValues).map((value, index) => {
            return (
              <td key={index} className="snapshot-table-column">
                {index == 0 ? (
                  <>
                    <img
                      src={
                        columnValues[value] === 0
                          ? ""
                          : columnValues[value] < 0
                          ? Lowarrow
                          : UpArrow
                      }
                      alt=""
                    />
                    <>
                      {columnValues[value] == undefined || null
                        ? "0"
                        : columnValues[value]}
                    </>
                  </>
                ) : (
                  <span
                    className={
                      columnValues[value] == 0
                        ? "text-muted"
                        : columnValues[value] < 0
                        ? "red-txt"
                        : "green-txt"
                    }
                  >
                    {columnValues[value] == undefined || null
                      ? "0"
                      : columnValues[value]}
                  </span> 
                )}
              </td>
            );
          })} */}
        </tr>
      );
    });
  };

  const showRevenueEquModal = (revenueEquModel) => {
    return (
      revenueEquModel &&
      revenueEquModel.map((data, key) => {
        return (
          <tr key={key} className="snapshot-table-row">
            <td>
              <a
              className="overall-aum-new"
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(data.clientCode, "");
                  getTabStatus("");
                }}
              >
                {checkEmpty(data.clientCode) || data.clientCode == ""
                  ? "-"
                  : data.clientCode}
              </a>
            </td>
            <td>
              {checkEmpty(data.clientName) || data.clientName == ""
                ? "-"
                : data.clientName}
            </td>
            <td>
              {checkEmpty(data.isin) || data.isin == "" ? "-" : data.isin}
            </td>
            <td>{checkEmpty(data.pBrokDel) ? "-" : data.pBrokDel}</td>
            <td>
              {checkEmpty(data.pBrokTrd)
                ? "-"
                : numDifferentiationWithoutSymbol(data.pBrokTrd)}
            </td>
            <td>
              {checkEmpty(data.sBrokDel)
                ? "-"
                : numDifferentiationWithoutSymbol(data.sBrokDel)}
            </td>
            <td>{checkEmpty(data.sBrokTrd) ? "-" : data.sBrokTrd}</td>
            <td>{checkEmpty(data.saudaDate) ? "-" : data.saudaDate}</td>
            <td>{checkEmpty(data.scripCode) ? "-" : data.scripCode}</td>
            <td>{checkEmpty(data.scripName) ? "-" : data.scripName}</td>
          </tr>
        );
      })
    );
  };

  const showRevenueFnoModal = (revenueFuturesModel) => {
    return (
      revenueFuturesModel &&
      revenueFuturesModel.map((data, key) => {
        return (
          <tr key={key} className="snapshot-table-row">
            <td>
              <a
              className="overall-aum-new"
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(data.clientCode, "");
                  getTabStatus("");
                }}
              >
                {checkEmpty(data.clientCode) ? "-" : data.clientCode}
              </a>
            </td>
            <td>{checkEmpty(data.clientName) ? "-" : data.clientName}</td>
            <td>{checkEmpty(data.symbol) ? "-" : data.symbol}</td>
            <td>{checkEmpty(data.pBrok) ? "-" : data.pBrok}</td>
            <td>{checkEmpty(data.sBrok) ? "-" : data.sBrok}</td>
            <td>{checkEmpty(data.saudaDate) ? "-" : data.saudaDate}</td>
            <td>
              {checkEmpty(data.strikePrice)
                ? "-"
                : numDifferentiationWithoutSymbol(data.strikePrice)}
            </td>
          </tr>
        );
      })
    );
  };

  const showRevenueMTFModal = (revenueOptionsModel) => {
    return (
      revenueOptionsModel &&
      revenueOptionsModel.map((data, key) => {
        return (
          <tr key={key} className="snapshot-table-row">
            <td >
              <a
              className="overall-aum-new"
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(data.clientCode, "");
                  // Navigate("/client-dashboard");
                  getTabStatus("");
                }}
              >
                {checkEmpty(data.clientCode) ? "-" : data.clientCode}
              </a>
            </td>
            <td>{checkEmpty(data.clientName) ? "-" : data.clientName}</td>
            <td>{checkEmpty(data.symbol) ? "-" : data.symbol}</td>
            <td>{checkEmpty(data.pBrok) ? "-" : data.pBrok}</td>
            <td>{checkEmpty(data.sBrok) ? "-" : data.sBrok}</td>
            <td>{checkEmpty(data.saudaDate) ? "-" : data.saudaDate}</td>
            <td>{checkEmpty(data.strikePrice) ? "-" : data.strikePrice}</td>
          </tr>
        );
      })
    );
  };

  const handleSnapshotDuration = (e) => {
    setRevModalDuration(e?.target?.value);
  };

  return (
    <div className="snapshot-detail-block revenue-detail">
      <div className="card-title mb-0 aum-title">
        <span>{props.title}</span>

        <div className="wrap-modal-header">
          <div className="filter-options">
            {/* <!-- dropdown --> */}
            <div className="new-dropdown">
              <Form.Select
                size="lg"
                aria-label="Default select example"
                onChange={(e) => handleSnapshotDuration(e)}
              >
                <option value="yesterday">{Constants.Yesterday}</option>
                <option value="weekly">{Constants.Current_Week}</option>
                <option value="monthly">{Constants.Current_Month}</option>
                <option value="yearly">{Constants.Current_Year}</option>

                {/* <option value="Overall">Overall</option> */}
              </Form.Select>
            </div>
          </div>

          <div className="generate-btn-wrapper mt-0">
            <button
              className="generate-btn excel1 text-green new-excel-btn"
              value="excel"
              onClick={(e) => handleFileType(e)}
            >
              {props?.buttonLoader?.excel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  Excel
                </>
              )}
            </button>

            <button
              className="generate-btn pdf1 txt-purple new-pdf-btn"
              value="pdf"
              onClick={(e) => handleFileType(e)}
            >
              {props?.buttonLoader?.pdf ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-pdfsvg"></span> PDF
                </>
              )}
            </button>
          </div>

          <button
            type="button"
            className="btn-close snapshot-close-btn"
            aria-label="Close"
            onClick={() => {
              setShowRevModal(false);
              // setRevModalDuration("yesterday")
            }}
          >
            <span className="icon-close"></span>
          </button>
        </div>
      </div>

      <div className="snapshot-table scroll-table snapshot-new-table">
        <table className="table tabel-level1">
          <tr>
            {revModalDuration === "yesterday" ? (
              <>
                <div>
                  <th
                    colSpan="3"
                    scope="col"
                    className="col-width-tab duration-title"
                  >
                    {Constants.Yesterday}
                    <span> {Constants.Compare_Yesterday}</span>
                  </th>
                </div>
                <td className="for-width pb-0">
                  <table className="table table-level2">
                    {revenueLoader === true ? (
                      <div className="loader-alignment">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <thead>
                          <tr className="snapshot-head">
                            {/* <th className="header-width"></th> */}
                            <th
                              colSpan="3"
                              scope="col"
                              className="col-width-tab text-center snapshot-title"
                            >
                              Segment
                              {/* {Constants.Yesterday}
                            <br />
                            <span>{Constants.Compare_Yesterday}</span> */}
                            </th>
                            <th scope="col">{firstColumnTitle}</th>
                            <th scope="col">{Constants.Previous}</th>
                            <th scope="col">{Constants.Change}</th>
                            <th scope="col">{Constants.Change_Perc}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {revenueTable == null || undefined
                            ? handleifTableEmpty(true)
                            : generateOverallTableData(revenueTable, true)}
                        </tbody>
                      </>
                    )}
                  </table>
                </td>
              </>
            ) : revModalDuration === "weekly" ? (
              <>
                <div>
                  <th
                    colSpan="3"
                    scope="col"
                    className="col-width-tab duration-title"
                  >
                    {Constants.Current_Week}
                    <span> {Constants.Compare_Week}</span>
                  </th>
                </div>
                <td className="for-width pb-0">
                  <table className="table table-level2">
                    {revenueLoader === true ? (
                      <div className="loader-alignment">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <thead>
                          <tr className="snapshot-head">
                            <th
                              colSpan="3"
                              scope="col"
                              className="col-width-tab text-center snapshot-title"
                            >
                              Segment
                            </th>
                            {/* <th scope="col" className="header-width first-col"></th> */}
                            <th scope="col">{firstColumnTitle}</th>
                            <th scope="col">{Constants.Previous}</th>
                            <th scope="col">{Constants.Change}</th>
                            <th scope="col">{Constants.Change_Perc}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {revenueTable == null || undefined
                            ? handleifTableEmpty(true)
                            : generateSnapshotTableData(revenueTable, true)}
                        </tbody>
                      </>
                    )}
                  </table>
                </td>
              </>
            ) : revModalDuration === "monthly" ? (
              <>
                <div>
                  <th
                    colSpan="3"
                    scope="col"
                    className="col-width-tab duration-title"
                  >
                    {Constants.Current_Month}
                    <span> {Constants.Compare_Month}</span>
                  </th>
                </div>
                <td className="for-width pb-0">
                  <table className="table table-level2">
                    {revenueLoader === true ? (
                      <div className="loader-alignment">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <thead>
                          <tr className="snapshot-head">
                            <th
                              colSpan="3"
                              scope="col"
                              className="col-width-tab text-center snapshot-title"
                            >
                              Segment
                              {/* {Constants.Current_Month}
                                <br />
                                <span>{Constants.Compare_Month}</span> */}
                            </th>
                            <th scope="col">{firstColumnTitle}</th>
                            <th scope="col">{Constants.Previous}</th>
                            <th scope="col">{Constants.Change}</th>
                            <th scope="col">{Constants.Change_Perc}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {revenueTable == null || undefined
                            ? handleifTableEmpty(true)
                            : generateSnapshotTableData(revenueTable, true)}
                        </tbody>
                      </>
                    )}
                  </table>
                </td>
              </>
            ) : (
              <>
                <div>
                  <th
                    colSpan="3"
                    scope="col"
                    className="col-width-tab duration-title"
                  >
                    {Constants.Current_Year}
                    <span> {Constants.Compare_Year}</span>
                  </th>
                </div>
                <td className="for-width pb-0">
                  <table className="table table-level2">
                    {revenueLoader === true ? (
                      <div className="loader-alignment">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <thead>
                          <tr className="snapshot-head">
                            <th
                              colSpan="3"
                              scope="col"
                              className="col-width-tab text-center snapshot-title"
                            >
                              Segment
                            </th>
                            <th scope="col">{firstColumnTitle}</th>
                            <th scope="col">{Constants.Previous}</th>
                            <th scope="col">{Constants.Change} </th>
                            <th scope="col">{Constants.Change_Perc}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {revenueTable == null || undefined
                            ? handleifTableEmpty(true)
                            : generateSnapshotTableData(revenueTable, true)}
                        </tbody>
                      </>
                    )}
                  </table>
                </td>
              </>
            )}
          </tr>
        </table>
      </div>
      <Modal
        show={showModal}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model snapshot-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <p>{Constants.Revenue_Snapshot}
              <span style={{fontSize: "12px", color: "#666666", marginLeft: "7px"}}>(Equity)</span>
            </p>
          </Modal.Title>

          <div className="wrap-buttons-modal">
            <div className="generate-btn-wrapper mt-0">
              <button
                className="generate-btn excel1 text-green new-excel-btn"
                value="excel"
                onClick={() => getRevenueSnapshot("EQ", duration, "excel")}
              >
                {smallLoaderExcel ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-excelsvg"></span>
                    Excel
                  </>
                )}
              </button>

              <button
                className="generate-btn pdf1 txt-purple new-pdf-btn"
                value="pdf"
                onClick={() => getRevenueSnapshot("EQ", duration, "pdf")}
              >
                {smallLoaderPdf ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-pdfsvg"></span> PDF
                  </>
                )}
              </button>

              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onHide}
              >
                <span className="icon-close"></span>
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table snapshot-detail-table rev-table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : revenueEquModel && revenueEquModel.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>{Constants.Client_Code}</th>
                    <th>{Constants.client_Name}</th>
                    <th>{Constants.Isin}</th>
                    <th>PBrok Del</th>
                    <th>PBrok Trd</th>
                    <th>SBrok Del</th>
                    <th>SBrok Trd</th>
                    <th>{Constants.Sauda_Date}</th>
                    <th>{Constants.Scrip_Code}</th>
                    <th>{Constants.Scrip_Name}</th>
                  </tr>
                </thead>

                <tbody id="revenue-equ" onScroll={(e) => handleScroll("EQ", e)}>
                  {showRevenueEquModal(revenueEquModel)}

                  {infiniteScrollLoader && (
                  <div className="d-flex justify-content-center">
                    <LoaderForSearch />
                  </div>
                )}
                </tbody>
              </table>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="no-data">{serverError}</h4>
            ) : (
              noDataFound()
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModelFno}
        onHide={onHideFno}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model snapshot-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title>
            <p>{Constants.Revenue_Snapshot}
              <span style={{fontSize: "12px", color: "#666666", marginLeft: "7px"}}>(Futures)</span>
            </p>
          </Modal.Title>

          <div className="wrap-buttons-modal">
            <div className="generate-btn-wrapper mt-0">
              <button
                className="generate-btn excel1 text-green new-excel-btn"
                value="excel"
                onClick={(e) =>
                  getRevenueSnapshot("FUT", duration, e.target.value)
                }
              >
                {smallLoaderExcel ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-excelsvg"></span>
                    Excel
                  </>
                )}
              </button>

              <button
                className="generate-btn pdf1 txt-purple new-pdf-btn"
                value="pdf"
                onClick={(e) =>
                  getRevenueSnapshot("FUT", duration, e.target.value)
                }
              >
                {smallLoaderPdf ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-pdfsvg"></span>
                    PDF
                  </>
                )}
              </button>

              <button type="button" className="btn-close" onClick={onHideFno}>
                <span className="icon-close"></span>
              </button>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table snapshot-detail-table rev-table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : revenueFuturesModel?.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>{Constants.Client_Code}</th>
                    <th>{Constants.client_Name}</th>
                    <th>{Constants.Symbol}</th>
                    <th>PBrok</th>
                    <th>SBrok</th>
                    <th>{Constants.Sauda_Date}</th>
                    <th>{Constants.Strike_Price}</th>
                  </tr>
                </thead>

                <tbody
                  id="revenue-fno"
                  onScroll={(e) => handleScroll("FUT", e)}
                >
                  {showRevenueFnoModal(revenueFuturesModel)}
                  {infiniteScrollLoader && activeSegment === "FUT" && (
              <div className="d-flex justify-content-center">
                <LoaderForSearch />
              </div>
            )}
                </tbody>
              </table>
            ) : (
              noDataFound()
            )}

            
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModelMTF}
        onHide={onHideMTF}
        size="lg"
        centered
        className="inactive-modal setting-model snapshot-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title>
            <p>{Constants.Revenue_Snapshot}
              <span style={{fontSize: "12px", color: "#666666", marginLeft: "7px"}}>(Options)</span>
            </p>
          </Modal.Title>

          <div className="wrap-buttons-modal">
            <div className="generate-btn-wrapper mt-0">
              <button
                className="generate-btn excel1 text-green new-excel-btn"
                value="excel"
                onClick={(e) =>
                  getRevenueSnapshot("OPT", duration, e.target.value)
                }
              >
                {smallLoaderExcel ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-excelsvg"></span>
                    Excel
                  </>
                )}
              </button>

              <button
                className="generate-btn pdf1 txt-purple new-pdf-btn"
                value="pdf"
                onClick={(e) =>
                  getRevenueSnapshot("OPT", duration, e.target.value)
                }
              >
                {smallLoaderPdf ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-pdfsvg"></span>
                    PDF
                  </>
                )}
              </button>

              <button type="button" className="btn-close" onClick={onHideMTF}>
                <span className="icon-close"></span>
              </button>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table snapshot-detail-table rev-table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : revenueOptionsModel?.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>{Constants.Client_Code}</th>
                    <th>Client Name</th>
                    <th>Symbol</th>
                    <th>PBrok</th>
                    <th>SBrok</th>
                    <th>{Constants.Sauda_Date}</th>
                    <th>Strike Price</th>
                  </tr>
                </thead>

                <tbody
                  id="revenue-mtf"
                  onScroll={(e) => handleScroll("OPT", e)}
                >
                  {showRevenueMTFModal(revenueOptionsModel)}
                  {infiniteScrollLoader && activeSegment === "OPT" && (
              <div className="d-flex justify-content-center">
                <LoaderForSearch />
              </div>
            )}
                </tbody>
              </table>
            ) : (
              noDataFound()
            )}

            
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default React.memo(RevenueSnapshot);
